module.exports = __webpack_public_path__ + "img/clock-warning.170c5014.svg";